import React from 'react';

const SvgIcPayments = props => (
  <svg
    id="ic_payments_svg__Component"
    width={props.size || 149}
    height={props.size || 149}
    viewBox="0 0 149 149"
    xmlSpace="preserve"
    fill="#fff"
    {...props}
  >
    <defs>
      <linearGradient
        id="ic_payments_svg__linear-gradient"
        x2={1}
        y2={1.031}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#64ffe5" />
        <stop offset={1} stopColor="#16bf80" />
      </linearGradient>
    </defs>
    <path
      id="ic_payments_svg__ic_cupon"
      d="M6 0h137a6 6 0 016 6v137a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
      fill="url(#ic_payments_svg__linear-gradient)"
    />
    <g id="ic_payments_svg__money" transform="translate(25 19.11)">
      <g
        id="ic_payments_svg__Group_528"
        data-name="Group 528"
        transform="translate(0 39.555)"
      >
        <g id="ic_payments_svg__Group_527" data-name="Group 527">
          <path
            id="ic_payments_svg__Path_515"
            d="M84.5 160.017H1.424A1.422 1.422 0 000 161.437v39.876a1.422 1.422 0 001.42 1.424h56.49a1.424 1.424 0 000-2.848H2.848v-37.024h80.221v3.56a1.422 1.422 0 001.42 1.424 1.422 1.422 0 001.424-1.421v-4.987a1.422 1.422 0 00-1.413-1.424z"
            className="ic_payments_svg__cls-2"
            data-name="Path 515"
            transform="translate(0 -160.017)"
          />
        </g>
      </g>
      <g
        id="ic_payments_svg__Group_530"
        data-name="Group 530"
        transform="translate(3.322 17.958)"
      >
        <g id="ic_payments_svg__Group_529" data-name="Group 529">
          <path
            id="ic_payments_svg__Path_516"
            d="M87.51 71.006L21.055 56.054a1.424 1.424 0 00-1.7 1.08l-3.326 14.952a1.424 1.424 0 102.781.618l3.012-13.558 65.063 14.638a1.343 1.343 0 00.314.035 1.424 1.424 0 00.311-2.813z"
            className="ic_payments_svg__cls-2"
            data-name="Path 516"
            transform="translate(-15.995 -56.019)"
          />
        </g>
      </g>
      <g
        id="ic_payments_svg__Group_532"
        data-name="Group 532"
        transform="translate(21.572 7.982)"
      >
        <g id="ic_payments_svg__Group_531" data-name="Group 531">
          <path
            id="ic_payments_svg__Path_517"
            d="M149.07 24.706L109.2 8.092a1.429 1.429 0 00-1.828.68l-3.323 6.646a1.429 1.429 0 002.514 1.359q.022-.041.042-.083l2.726-5.456 38.642 16.1a1.428 1.428 0 101.1-2.635z"
            className="ic_payments_svg__cls-2"
            data-name="Path 517"
            transform="translate(-103.875 -7.982)"
          />
        </g>
      </g>
      <g
        id="ic_payments_svg__Group_534"
        data-name="Group 534"
        transform="translate(53.164 46.201)"
      >
        <g id="ic_payments_svg__Group_533" data-name="Group 533">
          <path
            id="ic_payments_svg__Path_518"
            d="M270.61 192.017h-13.186a1.424 1.424 0 000 2.848h13.186a1.424 1.424 0 000-2.848z"
            className="ic_payments_svg__cls-2"
            data-name="Path 518"
            transform="translate(-256 -192.017)"
          />
        </g>
      </g>
      <g
        id="ic_payments_svg__Group_536"
        data-name="Group 536"
        transform="translate(26.677 46.296)"
      >
        <g id="ic_payments_svg__Group_535" data-name="Group 535">
          <path
            id="ic_payments_svg__Path_519"
            d="M143.076 192.473a14.62 14.62 0 1014.62 14.62 14.62 14.62 0 00-14.62-14.62zm0 26.582a11.962 11.962 0 1111.962-11.962 11.962 11.962 0 01-11.962 11.962z"
            className="ic_payments_svg__cls-2"
            data-name="Path 519"
            transform="translate(-128.456 -192.473)"
          />
        </g>
      </g>
      <g
        id="ic_payments_svg__Group_538"
        data-name="Group 538"
        transform="translate(62.895 50.947)"
      >
        <g id="ic_payments_svg__Group_537" data-name="Group 537">
          <path
            id="ic_payments_svg__Path_520"
            d="M321.131 214.873c-8.805 0-18.275 2.08-18.275 6.646v39.873c0 4.565 9.47 6.646 18.275 6.646s18.275-2.08 18.275-6.646v-39.874c0-4.565-9.47-6.645-18.275-6.645zm14.952 46.494c-.251.922-5.233 3.348-14.952 3.348s-14.7-2.426-14.952-3.323v-2.612c3.535 1.781 9.375 2.612 14.952 2.612s11.419-.839 14.952-2.613zm0-6.646c-.251.922-5.233 3.348-14.952 3.348s-14.7-2.426-14.952-3.323v-2.612c3.535 1.781 9.375 2.612 14.952 2.612s11.419-.839 14.952-2.613zm0-6.646c-.251.922-5.233 3.348-14.952 3.348S306.43 249 306.179 248.1v-2.612c3.535 1.781 9.375 2.612 14.952 2.612s11.419-.839 14.952-2.613zm0-6.646c-.251.922-5.233 3.348-14.952 3.348s-14.7-2.426-14.952-3.323v-2.612c3.535 1.781 9.375 2.612 14.952 2.612s11.419-.839 14.952-2.613zm0-6.646c-.251.922-5.233 3.348-14.952 3.348s-14.7-2.426-14.952-3.323V232.2c3.535 1.773 9.375 2.612 14.952 2.612s11.419-.839 14.952-2.613zm0-6.645c-.251.922-5.233 3.348-14.952 3.348s-14.7-2.426-14.952-3.323v-2.612c3.535 1.773 9.375 2.612 14.952 2.612s11.419-.839 14.952-2.613zm-14.952-3.3c-9.7 0-14.685-2.419-14.952-3.293v-.01c.267-.925 5.248-3.343 14.952-3.343 9.636 0 14.62 2.382 14.952 3.323-.332.944-5.316 3.326-14.952 3.326z"
            className="ic_payments_svg__cls-2"
            data-name="Path 520"
            transform="translate(-302.856 -214.873)"
          />
        </g>
      </g>
      <g
        id="ic_payments_svg__Group_540"
        data-name="Group 540"
        transform="translate(6.644 46.201)"
      >
        <g id="ic_payments_svg__Group_539" data-name="Group 539">
          <path
            id="ic_payments_svg__Path_521"
            d="M53.354 218.6H40.8l-5.954-6.513v-10.8l6.576-6.421h11.932a1.424 1.424 0 100-2.848H40.839a1.425 1.425 0 00-1 .4l-7.421 7.239a1.785 1.785 0 00-.429 1.163v11.816a1.425 1.425 0 00.372.96l6.75 7.383a1.424 1.424 0 001.052.464h13.191a1.424 1.424 0 100-2.848z"
            className="ic_payments_svg__cls-2"
            data-name="Path 521"
            transform="translate(-31.992 -192.017)"
          />
        </g>
      </g>
      <path
        id="ic_payments_svg__Path_525"
        d="M349.377 42.842h.07a.864.864 0 00.119-.009 1.927 1.927 0 011.888 1.924.862.862 0 101.724 0 3.656 3.656 0 00-2.869-3.566v-.829a.862.862 0 10-1.724 0v.868a3.65 3.65 0 00.943 7.177 1.926 1.926 0 11-1.926 1.927.862.862 0 00-1.724 0 3.657 3.657 0 002.708 3.526v.945a.862.862 0 001.724 0V53.9a3.65 3.65 0 00-.781-7.216 1.925 1.925 0 01-.151-3.845zm0 0"
        className="ic_payments_svg__cls-2"
        data-name="Path 525"
        transform="translate(-308.087 13.742)"
      />
    </g>
  </svg>
);

export default SvgIcPayments;
